export default "__VITE_ASSET__BX8ir62d__"